import { getCourseDemoPeriodInfo } from './courseDemoPeriod'

export const getCourseOrderClassUser = (order) => {
  const classUsers = order?.class?.classUser
  const normalizedClassUsers = Array.isArray(classUsers)
    ? classUsers
    : [classUsers].filter(Boolean)

  return normalizedClassUsers.find(
    (item) => Number(item?.user_id) === Number(order?.children_id) && !item?.deleted_at,
  )
}

export const getCourseClassPaymentData = (order) => {
  const userClass = getCourseOrderClassUser(order)
  const demo = getCourseDemoPeriodInfo({ ...order, ...userClass })
  return {
    ...order?.class,
    next_payment_date: userClass?.next_payment_date ?? order?.next_payment_date,
    status_payment: userClass?.status_payment ?? order?.status_payment,
    is_demo: demo.isDemo,
    demo_started_at: userClass?.demo_started_at ?? order?.demo_started_at,
    demo_ends_at: userClass?.demo_ends_at ?? order?.demo_ends_at,
    payment_amount: !demo.isDemo && userClass?.amount != null
      ? userClass.amount
      : Math.max(0, Number(order?.class?.amount ?? 0) - Number(userClass?.discount ?? 0)),
  }
}

export const isFreeCourseOrder = (order, userClass) => {
  if (!order?.class) return order?.tariff?.type === 'free'

  const resolvedUserClass = userClass ?? getCourseOrderClassUser(order)
  if (getCourseDemoPeriodInfo({ ...order, ...resolvedUserClass }).isDemo) return false
  const amount =
    resolvedUserClass?.amount === null
      ? 0
      : Number(resolvedUserClass?.amount ?? -1)

  return amount === 0
}
